"use client";

import React from 'react';
import Icon from '@/components/ui/AppIcon';

const processSteps = [
  {
    icon: "BuildingOffice2Icon",
    title: "Factory",
    description: "Source directly from verified manufacturers"
  },
  {
    icon: "BuildingStorefrontIcon",
    title: "Warehouse",
    description: "Store in our Shenzhen facility"
  },
  {
    icon: "TruckIcon",
    title: "Global Delivery",
    description: "Ship worldwide with tracked logistics"
  }
];

export default function AnimatedProcessSection() {
  return (
    <section className="relative py-24 bg-secondary-dark overflow-hidden">
      <div className="container mx-auto px-6 relative z-10">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-text-primary mb-4">
            Seamless Process
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            From factory to your customer’s door — we handle everything
          </p>
        </div>

        {/* Process timeline */}
        <div className="max-w-5xl mx-auto">
          <div className="relative">
            {/* Animated path line */}
            <div className="absolute top-1/2 left-0 right-0 h-1 -translate-y-1/2 hidden md:block">
              <div 
                className="h-full rounded-full"
                style={{
                  background: "linear-gradient(90deg, #5B2EFF 0%, #7C4DFF 50%, #9F7AEA 100%)",
                  boxShadow: "0 0 20px rgba(91, 46, 255, 0.5)"
                }}
              />
            </div>

            {/* Steps */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10">
              {processSteps?.map((step, index) => (
                <div 
                  key={index}
                  className="flex flex-col items-center text-center animate-fade-in-up"
                  style={{ animationDelay: `${index * 0.2}s` }}
                >
                  {/* Icon container */}
                  <div 
                    className="relative w-24 h-24 rounded-2xl glass-card flex items-center justify-center mb-6 group hover:scale-110 transition-smooth"
                    style={{
                      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.4), 0 0 40px rgba(91, 46, 255, 0.3)"
                    }}
                  >
                    <Icon name={step?.icon} size={36} className="text-accent-primary" />
                    {/* Glow effect */}
                    <div 
                      className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity animate-glow-pulse"
                      style={{
                        background: "radial-gradient(circle, rgba(91, 46, 255, 0.4) 0%, transparent 70%)",
                        filter: "blur(20px)"
                      }}
                    />
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-bold text-text-primary mb-2">{step?.title}</h3>
                  <p className="text-text-secondary">{step?.description}</p>

                  {/* Step number */}
                  <div className="mt-4 w-8 h-8 rounded-full bg-accent-primary/10 border border-accent-primary/30 flex items-center justify-center">
                    <span className="text-sm font-bold text-accent-primary">{index + 1}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}